/** @jsxImportSource @emotion/react */
import React, { useContext } from 'react';
import { ThemeContext } from '../../../config/theme';
import themedStyles from './ActionButton.css';

export enum ButtonType {
  DEFAULT = 'default',
  DARK = 'dark',
}

export type Props = {
  type?: ButtonType;
  text?: string;
  disabled?: boolean;
  children?: unknown;
} & React.HTMLAttributes<HTMLButtonElement>;

function Button({ onClick, type = ButtonType.DEFAULT, text, disabled = false, children }: Props) {
  const styling = themedStyles(useContext(ThemeContext));

  const buttonStyle = () => {
    if (type === ButtonType.DARK) {
      return [styling.base, styling.dark];
    }

    return [styling.base, styling.default];
  };

  return (
    <button type="submit" css={buttonStyle} onClick={onClick} disabled={disabled}>
      {text || children || ''}
    </button>
  );
}

export default Button;
